import { ViewportIntersectionObserverUpdatedEventType } from "./viewport-intersection-observer.8d333c9ff0de.js";

/**
 * This is a sticky header that appears after scrolling past an unrelated element.
 *   (Simpler sticky situations can use `position: sticky` in CSS)
 *
 * A <tqc-sticky-header> and a <viewport-intersection-observer> both need to be on the page,
 *  and the <tqc-sticky-header> should load initially with `pv-hide`.
 *
 * The <viewport-intersection-observer> should wrap the element you want to scroll PAST
 * to reveal the sticky header.
 */
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    document.addEventListener(
      ViewportIntersectionObserverUpdatedEventType,
      this.updateVisibility,
    );
  }

  updateVisibility = (event) => {
    const scrolledPast =
      event.intersectionObserverEntry.boundingClientRect.bottom < 0;
    if (event.inView) {
      this.classList.add("pv-hide");
    } else if (scrolledPast) {
      this.classList.remove("pv-hide");
    }
  };
}

window.customElements.define("tqc-sticky-header", StickyHeader);
